export default __webpack_public_path__ + "static/media/file-attach.dd8e2539.svg";